var _desc, _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip303_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "logos:telegram",
    width: 32,
    height: 32,
    fill: "white",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1600,
    y1: 0,
    x2: 1600,
    y2: 3200,
    id: "paint_linear_303_4_0",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "logos:telegram",
    width: 32,
    height: 32,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip303_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0C11.75 0 7.68 1.68 4.68 4.68C1.68 7.68 0 11.75 0 16C0 20.24 1.68 24.31 4.68 27.31C7.68 30.31 11.75 32 16 32C20.24 32 24.31 30.31 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.75 30.31 7.68 27.31 4.68C24.31 1.68 20.24 0 16 0Z",
    fill: "url(#paint_linear_303_4_0)",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.24 15.83C11.9 13.79 15.01 12.45 16.57 11.81C21.01 9.96 21.94 9.64 22.54 9.63C22.67 9.62 22.97 9.66 23.16 9.81C23.32 9.94 23.36 10.12 23.39 10.25C23.41 10.37 23.43 10.65 23.41 10.88C23.17 13.41 22.13 19.55 21.6 22.38C21.38 23.58 20.93 23.98 20.51 24.02C19.58 24.11 18.87 23.41 17.97 22.82C16.56 21.89 15.77 21.32 14.4 20.42C12.82 19.38 13.85 18.8 14.75 17.87C14.98 17.62 19.08 13.9 19.15 13.56C19.16 13.52 19.17 13.36 19.08 13.28C18.99 13.2 18.85 13.23 18.75 13.25C18.61 13.28 16.36 14.77 12 17.71C11.36 18.15 10.78 18.36 10.26 18.35C9.69 18.34 8.59 18.03 7.78 17.76C6.78 17.44 5.98 17.26 6.05 16.71C6.08 16.42 6.48 16.13 7.24 15.83Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.16dd3f92c49e47ce23acd84af7c6dc66.svg";
export { ForwardRef as ReactComponent };